const timeout = 30000;

/**
 * Opens `url` in a new tab, listens for a message,
 * and sends a postMessage with refreshToken and accountId to the new tab
 */
export function openNewTabAndPostAuthInfo({
	refreshToken,
	accountId,
	url,
}: {
	refreshToken?: string;
	accountId?: string;
	url: URL;
}): Promise<boolean> {
	return new Promise((resolve) => {
		let resolved = false;

		function handler(event: MessageEvent) {
			if (event.origin !== location.origin) {
				return;
			}
			if (typeof event.data !== "object") {
				return;
			}
			if (event.data.subject !== "__VERITY_AUTH_GET") {
				return;
			}
			event.source?.postMessage({
				subject: "__VERITY_AUTH_RESP",
				payload: { refreshToken, accountId },
			});

			resolved = true;
			resolve(true);

			// cleanup
			window.removeEventListener("message", handler);
		}
		window.addEventListener("message", handler);

		window.open(url, "_blank", "noopener=false,noreferrer=false")?.focus();

		// cleanup if no timely get message
		setTimeout(() => {
			if (!resolved) {
				resolve(false);
				window.removeEventListener("message", handler);
			}
		}, timeout);
	});
}

/**
 * Sends a message to window.opener then listens for authentication info response
 */
export function listenOpenerAuthInfo(): Promise<{ refreshToken?: string; accountId?: string }> {
	return new Promise((resolve, reject) => {
		if (!window.opener) {
			reject("No opener found");
			return;
		}

		let resolved = false;

		function handler(event: MessageEvent) {
			if (event.origin !== location.origin) {
				return;
			}
			if (typeof event.data !== "object") {
				return;
			}
			if (event.data.subject !== "__VERITY_AUTH_RESP") {
				return;
			}
			resolved = true;
			resolve(event.data.payload as { refreshToken?: string; accountId?: string });

			// cleanup
			window.removeEventListener("message", handler);
		}
		window.addEventListener("message", handler);

		(window.opener as Window).postMessage(
			{
				subject: "__VERITY_AUTH_GET",
			},
			location.origin,
		);

		// cleanup if no timely response
		setTimeout(() => {
			if (!resolved) {
				reject("Authentication info opener event listener timed out");
				window.removeEventListener("message", handler);
			}
		}, timeout);
	});
}
